import {
    MAX_LOAN_AMOUNT,
    MAX_LOAN_TERM,
    MAX_SECURED_LOAN_AMOUNT,
    MIN_SECURED_LOAN_AMOUNT,
    MIN_LOAN_AMOUNT,
    MIN_LOAN_TERM,
} from 'constants/loanFilterLimits'

import { LoanProductCategory } from '@appTypes/LoansApi.interface'

export interface LoanFilterLimits {
    loanAmount: { max: number; min: number }
    loanTerm: { max: number; min: number }
}

export function getCategoryLoanFilterLimits(
    category?: LoanProductCategory
): LoanFilterLimits {
    switch (category) {
        case LoanProductCategory.Secured: {
            return {
                loanAmount: {
                    min: MIN_SECURED_LOAN_AMOUNT,
                    max: MAX_SECURED_LOAN_AMOUNT,
                },
                loanTerm: {
                    min: MIN_LOAN_TERM,
                    max: MAX_LOAN_TERM,
                },
            }
        }
        default: {
            return {
                loanAmount: {
                    min: MIN_LOAN_AMOUNT,
                    max: MAX_LOAN_AMOUNT,
                },
                loanTerm: {
                    min: MIN_LOAN_TERM,
                    max: MAX_LOAN_TERM,
                },
            }
        }
    }
}
